import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import {MessageType, PostStatus} from "root/DataFunctions/Constants";

import {
  defaultTableHeaderStyles,
  defaultPaginationOptions,
  customHeaderStyle,
  defaultTopLeftCellStyle,
  defaultTopRightCellStyle,
  TableActionIconGeneric, TableActionIconView
} from "./BaseTableComponents";

import './Table.scss'

const ApprovalsTable = (props) =>
{
  const onClickItem = ( mode, child_uid, post_id, message_type_id ) =>
  {
    props.clickHandler (mode, child_uid, post_id, message_type_id, props.onDialogClosed );
  }

  const linkFormatter = (cell, row, rowIndex, formatExtraData) => {
    const isDraft = +(row.status) === PostStatus.NOT_SENT;
    const isReturned = +(row.status) === PostStatus.RETURNED;
    const isHeld = +(row.status) === PostStatus.PENDING;
    const isArchived = +(row.status) === PostStatus.HELD;
    const isApproved = +(row.status) === PostStatus.APPROVED;
    const isNew = +(row.status) === PostStatus.NEW;
    const shouldShowAction = isHeld || isApproved || isArchived || isNew || isReturned;

    return (
        <Fragment>
          { shouldShowAction && <TableActionIconGeneric onClick={() => onClickItem('Action', null, row.post_id, row.message_type_id)} style={{marginRight: '10px'}} icon='icon-components' color='var(--s360-icon-green)' text='Approve/Return'/> }
          {/* <TableActionIconView text="View Item" onClick={() => onClickItem('View', null, row.post_id, row.message_type_id)} />*/}
        </Fragment>
    );
  }

  function toFromFormatter(cell, row, rowIndex, formatExtraData)
  {
    //Check we have a posted by and known as
    const posted_by_name = row.posted_by_name !== null && row.posted_by_name !== '' ? row.posted_by_name : row.fullName;
    const posted_to_name = row.known_as !== null && row.known_as !== '' ? row.known_as : row.toName;

    switch (+row.message_type_id)
    {
      case  MessageType.MESSAGE_TYPE_LIFESTORY:
        return (
            <Fragment>
              <i className="icon icon-camera" style={{fontSize: '1.5rem', marginRight: '7px', marginBottom: '3px'}}/>
              <span>From: {posted_by_name} - To: {posted_to_name}</span>
            </Fragment>
        );

        break;

      case  MessageType.MESSAGE_TYPE_MESSAGE:
        return (
            <Fragment>
              <i className="icon icon-chat" style={{fontSize: '1.5rem', marginRight: '7px', marginBottom: '3px'}}/>
              <span>From: {posted_by_name} - To: {posted_to_name}</span>
            </Fragment>
        );

        break;
    }
  }

  const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
  {
    const style = statusColor( row.status );
    const text = statusText( row.status );

    return (
        <Fragment>
          <span style={style}>{text}</span><br/>
        </Fragment>
    );
  }

  const statusColor = ( status ) =>
  {
    switch ( +status )
    {
      case PostStatus.RETURNED:
        return { color: 'red' };
      case PostStatus.NOT_SENT:
        return { color: 'blue' };
      case PostStatus.NEW:
        return { color: 'blue' };
      case PostStatus.APPROVED:
        return { color: 'green' };
      default:
        return { color: 'blue' };
    }
  }

  const statusText = ( status ) =>
  {
    switch ( +status )
    {
      case PostStatus.RETURNED:
        return 'Returned';
      case PostStatus.NOT_SENT:
        return 'Draft';
      case PostStatus.NEW:
        return 'Submitted';
      case PostStatus.APPROVED:
        return 'Approved';
      case PostStatus.HELD:
        return 'Archived';
      case PostStatus.PENDING:
        return 'Held';
    }
  }

  const headerStyle = customHeaderStyle.bind(null, {
    default: defaultTableHeaderStyles,
    posted_date: {borderRadius: defaultTopLeftCellStyle, width: "6vw"},
    fullName: {borderRadius: defaultTopLeftCellStyle, width: "auto"},
    to_name: {borderRadius: defaultTopLeftCellStyle, width: "10vw"},
    title: {width: "20vw"},
    view: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
  });

  const getColumns = () => {
    const columns = [
      {
        dataField: "posted_date",
        text: "Sent On",
        headerStyle: headerStyle
      },
      {
        dataField: "fullName",
        text: "From/To",
        sort: false,
        formatter: toFromFormatter,
        headerStyle: headerStyle
      },
      {
        dataField: "title",
        text: "Title",
        sort: false,
        headerStyle: headerStyle
      },
      {
        dataField: "post_status_title",
        text: "Status",
        textAlign: "center",
        formatter: statusFormatter,
        headerStyle: headerStyle
      },
      {
        dataField: "view",
        text: "Options",
        align: 'right',
        formatter: linkFormatter,
        headerStyle: headerStyle
      }
    ];

    return columns;
  };

  const translations = xlateBootstrapTableColumns(getColumns());
  const columns = React.useMemo(() => translations, []);

  const thisTableContent = () =>
  {
    return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
  }

  return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default ApprovalsTable;

ApprovalsTable.propTypes = {
  post_id: PropTypes.string,
  data: PropTypes.array,
  loading: PropTypes.bool
};